/**
 * Options:
 * - disabled - disabled state
 * - open - open state
 *
 * @public
 * - render() - render the view
 * - setState(state) - set view state
 *
 * @events
 * LocalcommunitySelectField:click
 */

import View from 'view/view'
import Model from 'model/model'
import template from 'component/community_selector/template/localcommunity_select_field.tmpl'
import RegistrationCommunitySearchResultView from 'component/quick_search/view/registration_community_search_result'

const HomeCommunityView = View.extend({
    className: 'localcommunitySelect',
    template,

    events: {
        click: '_onClick',
    },

    initialize(options) {
        options = options || {}

        this.listenTo(this.model, 'change', this.render)

        this._model = {
            state: new Model({
                disabled: options.disabled,
                open: options.open,
            }),
        }

        this.listenTo(this._model.state, 'change', this.render)
    },

    render() {
        this.destroySubviews()

        this.$el.html(
            this.template({
                community: this.model.toJSON(),
                state: this._model.state.toJSON(),
            })
        )

        // render community if it's not empty
        if (this.model.get('id')) {
            this.initSubview(RegistrationCommunitySearchResultView, {
                el: this.$('.js-lcs-field'),
                model: this.model,
                info: false,
                silent: true,
            }).render()
        }

        return this
    },

    _onClick() {
        if (this._model.state.get('disabled')) {
            return
        }

        this.trigger('LocalcommunitySelectField:click')
    },

    setState(state) {
        this._model.state.set(state)
        return this
    },
})

export default HomeCommunityView
